/**
 * Etichetta per la camera assegnata: antepone "Camera " se il testo non contiene già "camera".
 * Valori come "Da assegnare" / "N/D" restano invariati.
 * @param {string|null|undefined} raw
 * @returns {string}
 */
export function formatCameraAssegnata(raw) {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  const lower = s.toLowerCase();
  if (lower === "da assegnare" || lower === "n/d") return s;
  if (lower.includes("camera")) return s;
  return `Camera ${s}`;
}
